import { Button, useMediaQuery } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import { getButtonSize } from './Types';

function NoAvailabilityButton() {
  const breakPoint = useMediaQuery();

  return (
    <Button
      className="min-w-full sm:min-w-48"
      color="gray"
      radius="md"
      size={getButtonSize(breakPoint)}
      data-intercom-target="group-coaching-no-availability-button"
      disabled
    >
      <T kind="No availability" />
    </Button>
  );
}

export default observer(NoAvailabilityButton);
